import React from 'react';

export default function ArbitragePage() {
  return (
    <>
    
    </>
  );
}
